import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    message: { type: String, default: "¿Estás seguro que quieres hacer esto?" },
    secondMessage: String,
  };

  confirm(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (this.hasSecondMessageValue && !window.confirm(this.secondMessageValue)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
}
